import { Skeleton } from '@mui/material';
import classNames from 'classnames';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  TemperatureVariable,
  temperatureVariables,
} from 'src/constants/deviceConstants';
import { Device } from 'src/store/models/Device';

import Sensor from '../../Sensor/Sensor';
import classes from './SensorData.module.scss';

export interface SensorDataProps {
  loading?: boolean;
  deviceDetails: Device;
  classes?: {
    sensor?: string;
    loading?: string;
    root?: string;
  };
}

const SensorData: FC<SensorDataProps> = ({
  loading = false,
  deviceDetails,
  classes: styles,
}) => {
  const { t } = useTranslation();

  const temperatures = deviceDetails?.controller?.temperatures;
  const variables = deviceDetails?.controller?.diagnostic?.variables;

  const temps: TemperatureVariable[] = useMemo(
    () =>
      temperatureVariables
        ?.map((temp) => {
          if (temp.variableId) {
            const value = variables?.find(
              (v) => v.id === temp.variableId
            )?.value;
            return { ...temp, value };
          }
          const value = temperatures?.find(
            (t) => t.id === temp.temperatureId && t.actualType
          )?.actual;
          return { ...temp, value };
        })
        ?.filter((temp) => temp.value),
    [temperatures, variables]
  );

  return (
    <div className={classNames(classes.Container, styles?.root)}>
      {!loading ? (
        <>
          <h5>{t('device:sensor_data')}</h5>
          <section>
            {temps?.map((temp, i) => (
              <Sensor
                key={i}
                title={temp?.label}
                value={temp?.value}
                minValue={temp?.minValue}
                maxValue={temp?.maxValue}
                className={classNames(classes.Sensor, styles?.sensor)}
              />
            ))}
            {[...Array(10 - temps?.length)]?.map((_, i) => (
              <Sensor
                key={i}
                title=""
                index={i + temps?.length + 1}
                className={classNames(classes.Sensor, styles?.sensor)}
              />
            ))}
          </section>
        </>
      ) : (
        <div className={classNames(classes.Loading, styles?.loading)}>
          <Skeleton animation="wave" variant="text" />
          <div>
            <Skeleton animation="wave" variant="rectangular" height={160} />
            <Skeleton animation="wave" variant="rectangular" height={160} />
            <Skeleton animation="wave" variant="rectangular" height={160} />
          </div>
        </div>
      )}
    </div>
  );
};

export default SensorData;
